import { styled } from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  background-color: var(--sub-background);
  .ant-picker {
    width: 200px;
    border: 1px solid var(--main-border);
    border-radius: 20px;
    height: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .ant-picker-active-bar {
      display: none;
    }
  }
  .ant-picker-range {
    width: 280px;
  }
  .ant-picker-clear {
    right: 35px;
  }
  .filter-container {
    padding: 0 30px;
    display: flex;
    gap: 12px;
    height: 60px;
    margin: 30px 0 20px 0;
  }
  .form-content {
    max-width: 700px;
    margin: 30px auto 56px;

    .ant-form-item {
      margin-bottom: 0;
      .block-title {
        font-size: 20px;
        font-family: var(--font-600);
        color: var(--brand-color);
      }
      .ant-form-item-label {
        padding-bottom: 12px;
        label {
          font-size: 16px;
          font-family: var(--font-600);
          color: var(--brand-color);
        }
      }
      .checkbox-label {
        font-size: 16px;
        line-height: 22.4px;
        font-family: var(--font-500);
        color: var(--brand-color);
      }
      .ant-checkbox-inner {
        width: 20px;
        height: 20px;
        border: 2px solid #14ae5c;
      }
      .ant-picker {
        width: 100%;
        height: 48px;
      }
      .unit {
        font-size: 16px;
        line-height: 22.4px;
        font-family: var(--font-600);
        color: var(--brand-color);
      }
      &.group-btn .ant-form-item-control-input-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 14px;
        .btn {
          display: flex;
          height: 52px;
          justify-content: center;
          align-items: center;
          gap: 4px;
          flex-shrink: 0;
          border-radius: 12px;
          border: none;
          font-size: 16px;
          line-height: 25.6px;
        }
        .btn-cancel {
          width: 160px;
          background: var(--grey-background);
          color: var(--brand-color) !important;
        }
        .btn-create {
          width: 220px;
          background: var(--brand-color);
          color: var(--light-color) !important;
        }
      }
    }
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  .btn-create {
    border-radius: 12px;
    background: var(--brand-color);
    color: var(--light-color) !important;
    width: 220px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
`;

export const Block = styled.div`
  background-color: var(--light-color);
  padding: 30px 20px;
  border-radius: 20px;
  margin-bottom: 16px;
  > .ant-form-item {
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export const PopupContent = styled.div`
  text-align: center;
  padding-top: 30px;
  p {
    margin-top: 10px;
    font-size: 16px;
  }
  .modal-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ccc;
    button {
      max-height: 45px;
      min-width: 100px;
    }
  }
`;

export const WrapUpload = styled.div`
  margin-bottom: 16px;
  display: flex;
`;
